import { render, staticRenderFns } from "./uploadAudio.vue?vue&type=template&id=00b83d42"
import script from "./uploadAudio.vue?vue&type=script&lang=js"
export * from "./uploadAudio.vue?vue&type=script&lang=js"
import style0 from "./uploadAudio.vue?vue&type=style&index=0&id=00b83d42&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports